import { Component, Input, HostListener, OnInit } from '@angular/core';
import { Icon, Image, RedirectionLinkType } from 'simpo-component-library';
import { TemplateService } from 'src/app/services/template.service';
import { MediaSelectorComponent } from '../../popups/media-selector/media-selector.component';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
// import { ImageUploadService } from 'src/app/services/ImageUploadService/image-upload.service';
import { ComponentImageUploadService } from 'src/app/services/component-image-upload.service';
import { EventsService } from 'simpo-component-library';
import { CustomDeleteComponent } from 'src/app/master-config-components/micro-apps/crm/custom-delete/custom-delete.component';
import { MatDialog } from '@angular/material/dialog';
import { ProductServiceService } from 'src/app/master-config-components/micro-apps/products/service/product-service.service';
import { DbService } from 'src/app/services/db-service/db.service';
@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss']
})
export class ImageEditorComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private templateService: TemplateService,
    private _eventHelper: EventEmmiterService,
    private imageUploadService: ComponentImageUploadService,
    private eventsService: EventsService,
    private productService: ProductServiceService,
    private _dbService: DbService,
  ) {
    this.screenSize()
  }

  ngOnInit(): void {
    const link = this.imageData?.content;
    if (link?.linkType === RedirectionLinkType.Page && link?.redirectionUrl &&
      (link.redirectionUrl.includes('collections=') || link.redirectionUrl.includes('category='))) {
      this.currentPageName = 'Product List';
      this.loadProductListData();
      this.parseProductListSelection(link.redirectionUrl);
    }
  }

  @HostListener('window:resize', ['$event'])
  screenSize(event?: any) {
    this.screenWidth = window.innerWidth;
  }

  public regenerateImageLoader: boolean = false;
  imageLoader: boolean = false;

  get displayUrl(): string {
    return this.imageData?.url || (this.imageData as any)?.attachment || '';
  }

  private syncImageUrl(url: string) {
    this.imageData.url = url;
    if ((this.imageData as any).attachment !== undefined) {
      (this.imageData as any).attachment = url;
    }
  }

  getUnsplaceImage() {
    this.regenerateImageLoader = true;
    this.imageLoader = true;
    setTimeout(() => {
      this.imageLoader = false
      this.templateService.searchPhotosInUnsplash(JSON.parse(String(localStorage.getItem('bDetails')))?.subIndustryName ?? '', 0, 100).subscribe((response: any) => {
        this.regenerateImageLoader = false;
        const index: number = Math.floor(Math.random() * (response.results.length));
        this.syncImageUrl(response.results[index].urls.full);
      }, (error) => {
        this.regenerateImageLoader = false;
      })
    }, 2500);
  }
  screenWidth: any;

  @Input() imageData: Image = {
    id: '',
    url: '',
    blurhash: '',
    altText: '',

    position: {
      x: 0,
      y: 0
    },
  };

  @Input() iconData: Icon = {
    url: '',
    color: ''
  };

  @Input() showImage: boolean = true;
  @Input() embedded: boolean = false;
  @Input() compact: boolean = false;
  @Input() sectionId!: string;
  @Input() templatePage: any[] = [];
  @Input() currentPageIndex: number = 0;
  // Slider related data
  max = 100;
  min = 0;

  tabs = [
    { name: 'CONTENT', label: 'Content', status: true },
    { name: 'STYLES', label: 'Styles', status: false }
  ];
  selectedTab: string = 'CONTENT';

  tabShift(name: string): void {
    this.tabs.forEach(t => t.status = t.name === name);
    this.selectedTab = name;
  }

  getLinkObject(): any {
    if (!this.imageData.content) {
      this.imageData.content = {
        label: '',
        linkType: RedirectionLinkType.Page,
        redirectionUrl: '',
        pageId: '',
        newTab: false
      };
    }
    return this.imageData.content;
  }

  getLinkType(): string {
    const link = this.getLinkObject();
    return link.linkType || 'none';
  }

  setLinkType(type: string) {
    const link = this.getLinkObject();
    link.linkType = type;
  }

  currentPageName: string = '';
  collectionList: any[] = [];
  categoryList: any[] = [];
  collectionPath: string = '';
  categoryPath: string = '';

  onPageChange(id: string) {
    const page = this.templatePage.find(p => p.id === id);
    if (page) {
      this.getLinkObject().redirectionUrl = page.path;
      this.currentPageName = page.pageName;
      this.collectionPath = '';
      this.categoryPath = '';
      if (this.currentPageName === 'Product List') {
        this.loadProductListData();
      }
    }
  }

  loadProductListData() {
    const businessId = this._dbService.getBusinessId();
    this.productService.getCollectionList({ businessId, pageNo: 0, pageSize: 100 }).subscribe({
      next: (res: any) => { this.collectionList = res?.data?.data ?? []; }
    });
    this.productService.getcategoriesList({ businessId, searchText: '', pageNo: 0, pageSize: 1000 }).subscribe({
      next: (res: any) => { this.categoryList = res?.data?.data ?? []; }
    });
  }

  private parseProductListSelection(url: string) {
    const query = url.split('?')[1];
    if (!query) return;
    const params = new URLSearchParams(query);
    this.collectionPath = params.get('collections') ?? '';
    this.categoryPath = params.get('category') ?? '';
  }

  addCollectionToPath() {
    this.rebuildProductListUrl();
  }

  addCategoryToPath() {
    this.rebuildProductListUrl();
  }

  // Deterministically rebuild the query string from the current collection/category
  // selections so changing/clearing either never duplicates or strips a param.
  private rebuildProductListUrl() {
    const link = this.getLinkObject();
    const base = (link.redirectionUrl || '').split('?')[0];
    const parts: string[] = [];
    if (this.collectionPath) parts.push('collections=' + this.collectionPath);
    if (this.categoryPath) parts.push('category=' + this.categoryPath);
    link.redirectionUrl = parts.length ? base + '?' + parts.join('&') : base;
  }
  deleteBGImage() {
    this.syncImageUrl('');
  }

  async updateImage(ev: any) {
    // const file = ev.srcElement.files[0];


    // this.imageData.url = "https://i.pinimg.com/736x/d8/33/be/d833be1b6ca0a22507b95a9530ad6b3e.jpg";
    if (this.screenWidth > 475) {
      let dialog = this.templateService.openDialogWithData(
        MediaSelectorComponent,
        '90vh',
        '50%',
        { multiple: false }
      )
      dialog.afterClosed().subscribe(
        (res: any) => {
          if (res?.length) {
            if (this.showImage)
              this.syncImageUrl(res[0].assets[0].url);
            else
              this.iconData.url = res[0].assets[0].url;
          }
        }
      )
      this._eventHelper.showSaveOption.emit({ data: true });
    }
    // if(this.screenWidth < 475){
    //   let dialog = this.templateService.openDialogWithData(
    //     MediaSelectorComponent,
    //     '90vh',
    //     'auto',
    //     {multiple:false}
    //   )
    //   dialog.afterClosed().subscribe(
    //     (res:any)=>{
    //       if (res?.length) {
    //         if(this.showImage)
    //           this.imageData.url = res[0].assets[0].url;
    //         else
    //           this.iconData.url = res[0].assets[0].url;
    //        }
    //     }
    //   )
    //   this._eventHelper.showSaveOption.emit({data:true});
    // }
  }

  // deleteImage(){
  //   this.imageData.url = ''
  // }
  hello() {

  }
  deleteImage() {
    const dialogRef = this.dialog.open(CustomDeleteComponent, {
      width: '400px',
      data: {
        heading: 'Delete image',
        subText: 'Are you sure you want to delete the image?',
        primaryButton: 'Delete',
        secondaryButton: 'Cancel'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.response === 'success') {
        if (this.showImage)
          this.syncImageUrl('');
        else
          this.iconData.url = '';

        this.templateService.openSnack('Image deleted successfully', 'Ok');
      }
    });
  }

  horizontalPosition() {
    this.eventsService.objectPositionChangeCheck.emit({
      id: this.sectionId + this.imageData.id,
      position: this.imageData.position
    })
  }
}
